// src/services/chatApi.js
import api from './api';

// ── Chats ─────────────────────────────────────────────────────────────────────
export const listMyChats   = ()                  => api.get('/chats').then(r => r.data);
export const getChat       = (id)                => api.get(`/chats/${id}`).then(r => r.data);
export const createDirect  = (userId)            => api.post('/chats/direct', { userId }).then(r => r.data);
export const createGroup   = (body)              => api.post('/chats/group', body).then(r => r.data);
export const updateChat    = (id, body)          => api.patch(`/chats/${id}`, body).then(r => r.data);
export const addMember     = (id, userId)        => api.post(`/chats/${id}/members`, { userId }).then(r => r.data);
export const removeMember  = (id, userId)        => api.delete(`/chats/${id}/members/${userId}`).then(r => r.data);
export const leaveChat     = (id)                => api.delete(`/chats/${id}/members/me`).then(r => r.data);
// deleteChat eliminado a propósito: el chat es un medio oficial y no se puede borrar.

// ── Mensajes ──────────────────────────────────────────────────────────────────
export const listMessages = (chatId, { before, limit = 50 } = {}) => {
    const params = { limit };
    if (before) params.before = before;
    return api.get(`/chats/${chatId}/messages`, { params }).then(r => r.data);
};

/** Envía mensaje con texto y/o adjuntos. files es un array de File nativos. */
export const sendMessage = (chatId, { content = '', files = [] } = {}) => {
    const form = new FormData();
    if (content) form.append('content', content);
    files.forEach(f => form.append('files', f));
    return api.post(`/chats/${chatId}/messages`, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
    }).then(r => r.data);
};

export const editMessage   = (chatId, msgId, content) =>
    api.patch(`/chats/${chatId}/messages/${msgId}`, { content }).then(r => r.data);

export const deleteMessage = (chatId, msgId) =>
    api.delete(`/chats/${chatId}/messages/${msgId}`).then(r => r.data);

export const markRead = (chatId) => api.post(`/chats/${chatId}/messages/read`).then(r => r.data);

/** URL de descarga autenticada de un adjunto. El navegador adjunta el header
 *  Authorization automáticamente solo si la petición pasa por el cliente axios;
 *  para enlaces directos (target=_blank) generamos una URL con token corto en
 *  el query — fallback simple: la API exige Authorization, así que en links
 *  directos seguimos usando la URL pública del adjunto. Esta función queda
 *  disponible para descargas vía fetch programático cuando se necesite. */
export const attachmentDownloadUrl = (chatId, msgId, idx) =>
    `${api.defaults.baseURL}/chats/${chatId}/messages/${msgId}/attachments/${idx}`;
